"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlIVec2Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl int32 vector2 uniform.
 */
class GlIVec2Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniform2iv(this.uniformLocation, data);
        this.isDirty = false;
    }
}
exports.GlIVec2Uniform = GlIVec2Uniform;
//# sourceMappingURL=gl-i-vec2-uniform.js.map